/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import map from 'lodash/map';

import { navigate } from '@reach/router';

import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

import Copyright from './components/Copyright';
import FacebookIcon from './assets/fb.svg';
import TwitterIcon from './assets/twit.svg';
import LinkedInIcon from './assets/linkedin.svg';

const styles = theme => ({
  root: {
    fontFamily: 'Raleway',
    fontSize: '14px',
    color: '#6a27e8',
  },
  contactSection: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      marginBottom: '8px',
    },
  },
  contact: { fontWeight: 'bold' },
  sitemap: {
    paddingLeft: '120px',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0px',
      textAlign: 'center',
    },
  },
  item: {
    fontWeight: 'bold',
    marginBottom: '24px',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      marginTop: '8px',
      marginBottom: '12px',
    },
  },
  subMenuItem: {
    marginBottom: '12px',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '4px',
    },
  },
  header: {
    fontWeight: 'bold',
    marginBottom: '24px',
    [theme.breakpoints.down('lg')]: {
      maxWidth: 100,
    },
    [theme.breakpoints.down('sm')]: {
      margin: '4px 0',
      maxWidth: 'none',
    },
  },
  socialIconsContainer: {
    [theme.breakpoints.down('sm')]: {
      marginTop: 16,
      marginBottom: 16,
      textAlign: 'center',
    },
  },
  facebookIcon: {
    width: 11,
    height: 25,
    objectFit: 'contain',
    marginRight: 14,
  },
  twitterIcon: {
    width: 26,
    height: 21,
    objectFit: 'contain',
    marginRight: 12,
  },
  linkedinIcon: {
    width: 22,
    height: 22,
    objectFit: 'contain',
  },
});

const menu1 = [
  { name: 'Home', url: '/' },
  { name: 'About', url: '/about' },
  { name: 'Why join', url: '/join' },
];

const menu2 = [
  { name: 'Referrer', url: '/survey/referrer' },
  { name: 'Partners', url: '/survey/partner' },
  { name: 'Affiliates', url: '/survey/affiliate' },
];

const menu3 = [
  { name: 'Reports', url: '/resources/reports' },
  { name: 'Graphs', url: '/resources/graphs' },
];

const menu4 = [
  { name: 'Blog', url: '/blog' },
  //{ name: 'Terms & Conditions', url: '/terms' },
];

const Footer = ({ classes, className }) => (
  <>
    <Grid container className={cn(classes.root, { [className]: !!className })}>
      <Grid item xs={12} md={3} className={classes.contactSection}>
        <div className={classes.contact}>Contact us</div>
        <div>SlashData, 19-21 Hatton Gardens,</div>
        <div>London, EC1N 8BA, United Kingdom,</div>
        <div>+44 845 003 8742, +44 845 003 8787</div>
        <div>community@developereconomics.com</div>
      </Grid>
      <Grid item xs={12} md={7} className={classes.sitemap}>
        <Grid container>
          <Grid item xs={12} md={3}>
            {map(menu1, item => (
              <div
                key={`footer-menu-item-${item.name}`}
                className={classes.item}
                onClick={() => navigate(item.url)}
              >
                {item.name}
              </div>
            ))}
          </Grid>
          <Grid item xs={12} md={3}>
            <div className={classes.header}>Promote the Survey</div>
            {map(menu2, item => (
              <div
                key={`footer-menu-item-${item.name}`}
                className={classes.subMenuItem}
                onClick={() => navigate(item.url)}
              >
                {item.name}
              </div>
            ))}
          </Grid>
          <Grid item xs={12} md={3}>
            <div className={classes.header}>Resources</div>
            {map(menu3, item => (
              <div
                key={`footer-menu-item-${item.name}`}
                className={classes.subMenuItem}
                onClick={() => navigate(item.url)}
              >
                {item.name}
              </div>
            ))}
          </Grid>
          <Grid item xs={12} md={3}>
            {map(menu4, item => (
              <div
                className={classes.item}
                key={`footer-menu-item-${item.name}`}
                onClick={() => navigate(item.url)}
              >
                {item.name}
              </div>
            ))}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={2} className={classes.socialIconsContainer}>
        <a
          href={`https://www.facebook.com/${process.env.GATSBY_FACEBOOK_ACCOUNT_NAME}`}
          target="_black"
          rel="noopener noreferrer"
        >
          <img
            src={FacebookIcon}
            alt="facebook"
            className={classes.facebookIcon}
          />
        </a>
        <a
          href={`https://twitter.com/${process.env.GATSBY_TWITTER_ACCOUNT_NAME}`}
          target="_black"
          rel="noopener noreferrer"
        >
          <img
            src={TwitterIcon}
            alt="twitter"
            className={classes.twitterIcon}
          />
        </a>
        <a
          href={`https://www.linkedin.com/company/${process.env.GATSBY_LINKEDIN_ACCOUNT_NAME}`}
          target="_black"
          rel="noopener noreferrer"
        >
          <img
            src={LinkedInIcon}
            alt="linkedin"
            className={classes.linkedinIcon}
          />
        </a>
      </Grid>
    </Grid>
    <Copyright />
  </>
);

Footer.propTypes = {
  classes: PropTypes.shape().isRequired,
};

export default withStyles(styles, { name: 'footer' })(Footer);
